import script from "./YouTubeBreakdownSheet.vue?vue&type=script&setup=true&lang=js"
export * from "./YouTubeBreakdownSheet.vue?vue&type=script&setup=true&lang=js"

import "./YouTubeBreakdownSheet.vue?vue&type=style&index=0&id=ed2320f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed2320f0"]])

export default __exports__